<div class="ui-grid" *ngIf="preferredSupplier">
  <h1>Supplier Details</h1>

  <div class="ui-g">
    <div class="ui-g-12 ui-md-2">
      <strong>Name</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ preferredSupplier.name }}
    </div>
    <div class="ui-g-12 ui-md-2">
      <strong>Address Line 1</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ preferredSupplier.addressLine1 }}
    </div>
    <div class="ui-g-12 ui-md-2">
      <strong>Address Line 2</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ preferredSupplier.addressLine2 }}
    </div>
    <div class="ui-g-12 ui-md-2">
      <strong>Address Line 3</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ preferredSupplier.addressLine3 }}
    </div>
    <div class="ui-g-12 ui-md-2">
      <strong>Town</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ preferredSupplier.town }}
    </div>
    <div class="ui-g-12 ui-md-2">
      <strong>Postcode</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ preferredSupplier.postcode | postcode }}
    </div>
    <div class="ui-g-12 ui-md-2">
      <strong>Email address</strong>
    </div>
    <div class="ui-g-12 ui-md-4">
      {{ preferredSupplier.emailAddress }}
    </div>
  </div>

  <div class="ui-g-12 ui-md-12">
    <a
      class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
      [routerLink]="['/app/preferredsuppliers']"
      title="Go back"
      pButton
    >
      <span class="ui-button-text ui-c">Back</span>
    </a>
  </div>
</div>
<div *ngIf="isLoading">Loading...</div>
